// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bhj_a","AdSlotBranding__desktop":"bhj_b","AdSlotBranding__mobile":"bhj_c"};